import { Directive, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DynamicQuestion } from "app/inscription/store/cotisation-form/inscription.model";

@Directive()
export abstract class AbstractDynamicInput {
  @Input() question: DynamicQuestion;
  @Input() control: UntypedFormControl;
  @Input() summary: boolean = false;

  constructor(public translate: TranslateService) { }
}